<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-header height="45px" class="head">
				<el-switch style="padding-left:20px" v-model="showUnsendwln" @change="showUnsendwlnChange" active-text="万里牛未同步" inactive-text=""></el-switch>
				<el-switch style="padding-left:20px" v-model="showUnsendjindie" @change="showUnsendjindieChange" active-text="星空未同步" inactive-text=""></el-switch>
			</el-header>
			<el-main class="main flex">
				<vxe-grid v-if="list_gridOptions" ref="flowffyreport" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>		
			</el-main>
		</el-container>
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
			bancktype: {
				default: () => {
					return ''
				}
			},			
		},
		data() {
			return {
				loading:false,
				showUnsendjindie:false,
				showUnsendwln:false,
				showtransferaccount:false,
				transTime: null,
				reportName: 'reconciliation_bankflow',
				foreingKey:{},
				list_formConfig: [{
					field: 'accName',
					title: '户名',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'serialNo',
					title: '单据编码',
					span: 4,
					itemRender: {
						name: '$input',
						props:{
							
						}
					}
				},{
					field: 'bankAcc',
					title: '账号',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'costordertype',
					title: '费用项',
					span: 4,
					itemRender: {
						name: '$emun',
						props:{
							name:'costordertype',
							formatter:'costordertype'
						}
					}
				},{
					field: 'store',
					title: '店铺',
					span: 4,
					itemRender: {
						name: '$emun',
						props:{
							name:'store',
							formatter:'store'
						}
					}
				},{
					field: 'warehouse',
					title: '仓库',
					span: 4,
					itemRender: {
						name: '$warehouse',
						props:{
							formatter:'warehouse'
						}
					}
				},{
					field: 'transTime',
					title: '时间',
					span: 4,
					itemRender: {
						name: '$datePicker',
						props:{}
					}
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},
		methods: {
			list(page,updateForm,other) {
				return new Promise(resolve => {
					this.$api.report.reportlist(this.reportName,{
						...page,
						...updateForm,
						...other,
						...this.foreingKey,
						...{
							fundtype:this.fundtype,
							bancktype:this.bancktype,
						}
					}).then((res) => {
						this.sourcedata = JSON.parse(JSON.stringify(res.list))
						if (this.afterGet) {
							this.afterGet(res,updateForm)
						}
						resolve(res)
					}, () => {
						resolve([])
					})
				})
			},
			showUnsendwlnChange(e){
				this.foreingKey.showUnsendwln = e?1:0
				this.customreload()
			},
			showtransferaccountChange(e){
				this.foreingKey.showtransferaccount = e?1:0
				this.customreload()
			},
			showUnsendjindieChange(e){
				this.foreingKey.unsendjindie = e?1:0
				this.customreload()
			},			
			list_beforeCreateGrid(gridOptions){
				gridOptions.id = 'ffyreport_list'
				gridOptions.pagerConfig.enabled = true
				gridOptions.columns = [{
						type: 'checkbox',
						title: '',
						field:'',
						fixed:'left',
						width:50
					},
					{field:'serialNo',title:'单据编码',render:'$input',props:{show:true},fixed:'left',width:'auto'},
					{field:'accName',title:'户名',render:'$input',props:{show:true},width:'auto'},
					{field:'bankAcc',title:'账号',render:'$input',props:{show:true},width:'auto'},
					{
						field:'transTime',
						title:'时间',
						render:'$datePicker',
						formatter:({cellValue})=>{
							return window.systemMethods.timestampToDate(cellValue)
						},
						props:{show:true},
						width:'auto',
					},
					{field:'amt',title:'合计金额',render:'',props:{show:true},width:'auto'},
					{
						field:'costordertype',
						title:'费用项',
						width:'auto',
						formatter:({cellValue})=>{
							return window.systemMethods.getEmunValue('costordertype',cellValue)
						},
					},
					{field:'costamount',title:'明细金额',render:'',props:{show:true},width:'auto'},
					{
						field:'businessdepartmentid',
						title:'业务部门',
						width:'auto',
						formatter:({cellValue})=>{
							return window.systemMethods.getdepartment(cellValue)
						},
					},
					{
						field:'store',
						title:'店铺',
						width:'auto',
						formatter:({cellValue})=>{
							return window.systemMethods.getEmunValue('store',cellValue)
						},
					},
					{
						field:'warehouseid',
						title:'仓库',
						width:'auto',
						formatter:({cellValue})=>{
							return window.systemMethods.getwarehouse(cellValue)
						},
					},
					{field:'invoice_file',title:'发票',render:'',props:{show:true},width:'auto',formatter:'file'},
					{field:'invoiceattr',title:'发票类型',render:'',props:{show:true},width:'auto',formatter:'invoiceattr'},					
					{field:'export_wln',title:'万里牛',render:'',props:{show:true},fixed:'right',width:'auto'},
					{field:'export_jindie',title:'金蝶',render:'',props:{show:true},fixed:'right',width:100},
					{field:'export_jindie_type',title:'金蝶模块',render:'',props:{show:true},fixed:'right',width:100},
				]
				gridOptions.checkboxConfig = null
				
				gridOptions.toolbarConfig.buttons = [{
					name: '导出',
					status: 'success',
					code: 'export'
				},{
					name: '同步万里牛',
					status: 'success',
					code: 'sendwln'
				},{
					name: '同步金蝶',
					status: 'danger',
					code: 'sendjindie'
				}]
				gridOptions.columns.forEach((item)=>{
					if(item.field=='serialNo'){
						item.slots = {
							default: ({row}) => {	
								let str= []
								if(row.cdSign==1){
									str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">支</el-tag>)
								}
								if(row.cdSign==0){
									str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">收</el-tag>)
								}
								str.push(<span>{row.serialNo}</span>)
								return str
							}
						}
					}
					if(item.field=='export_wln'){
						item.slots = {
							default:({row})=>{
								if(!row.export_wln){
									if(row.export_wln_error){
										return <span style="color:#F56C6C;">{row.export_wln_error}</span> 
									}else{
										return <span style="color:#F56C6C;">未同步</span> 							
									}	
								}else{
									return <span>{row.export_wln}</span> 	
								}
							}
						}
					}
					if(item.field=='export_jindie'){
						item.slots = {
							default:({row})=>{
								if(row.export_jindie_sucess!=1){
									if(row.export_jindie_error){
										return <span style="color:#F56C6C;">{row.export_jindie_error}</span> 
									}else{
										return <span style="color:#F56C6C;">未同步</span> 							
									}	
								}else{
									return <span style="color:#67C23A;">已同步</span> 	
								}
							}
						}
					}
				})
			},
			sendjindie(){
				let data =  this.$refs.flowffyreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				data.forEach((item)=>{
					this.loading = true
					this.$api.reconciliation_bankflow.sendjindie({
							serialNo:item.serialNo,
						}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})
			},
			sendwln(){
				let data =  this.$refs.flowffyreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}		
				let haspost = []		
				data.forEach((item)=>{
					if(!haspost.includes(item.serialNo)){
						haspost.push(item.serialNo)
						this.loading = true
						this.$api.reconciliation_bankflow.sendwln({
								serialNo:item.serialNo,
							}).then(()=>{
							this.loading = false
							this.customreload()
						},()=>{
							this.loading = false
						})
					}

				})				
			},
			receipt(row) {
				this.param = {code:row.paymentapplicationcode}
				this.$nextTick(()=>{
					this.$refs.receiptBox.modalShow()
				})
				// this.currentrow = row
				// let handle = this.$loading()
				// this.$api.paymentapplication.getReceiptInfo({
				// 	supplierwlnid: row.purchasesupplierid,
				// 	id: row.paymentapplicationid,
				// 	type: row.ordertype
				// }).then((res) => {
				// 	this.receiptInfo = res
				// 	this.receiptType = row.ordertype
				// 	this.$loadingclose(handle)
				// 	this.$refs.receiptBox.modalShow()

				// },()=>{
				// 	this.$loadingclose(handle)
				// })
				
			},
			settlement(row) {
				let handle = this.$loading()
				this.$api.reconciliationcurrent.settlement({
					id: row.id,
					wlnid: row.purchasesupplierid,
					purchasecode: row.serialNo
				}).then(() => {
					this.$loadingclose(handle)
					this.$message.success('操作成功')
					this.customreload()

				}, () => {
					this.$loadingclose(handle)
				})
				console.log(row)
			},
			cellStyle({
				row,
				column
			}) {
				if (column.property && column.property.indexOf('haspaper') !== -1) {
					if (row.haspaper == 6) {
						return {
							color: '#F56C6C'
						}
					}
					if (row.haspaper == 5) {
						return {
							color: '#67C23A'
						}
					}
				}
			},
			paymentsummary() {
				let form = this.$refs.flowffyreport.getProxyInfo().form
				this.transTime = form.transTime
				this.$refs.statistics.modal_show()
			},

			edit(row){
				this.currentrow = row
				this.$refs.rowedit.modalShow()
			},
			success(){
				this.customreload()
			},
			customreload(){
				this.$refs.flowffyreport.commitProxy('query')
			},
			exportdetail(e){
				let obj = {}
				obj.data = e.data
				obj.columns = this.$refs.flowffyreport.getColumns()
				this.$refs[this.exportRef].exportData(obj)
			}
		},
		components: {
			// exportTable,
			// receiptIndex,
			// statisticsIndex,
			// editIndex
		}
	}
</script>